<template>
  <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary" class="add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal">
    <div class="mt-6 flex items-center justify-between px-6">
        <h4>编辑个人信息</h4>
        <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>

    <VuePerfectScrollbar class="scroll-area--data-list-add-new pt-4 pb-6" :settings="settings">
      <div class="px-6">
        <vs-input label="*昵称" name="nickname" v-model="userInfo.displayName" class="mt-5 w-full" placeholder="起个厉害的名字！" />
        <vs-input label="手机号" name="phone" v-model="userInfo.phone" class="mt-5 w-full" />
        <vs-input label="邮箱" name="email" v-model="userInfo.email" class="mt-5 w-full" />
        <vs-textarea label="个性签名" name="motto" v-model="userInfo.motto" class="mt-5 w-full" />
      </div>
    </VuePerfectScrollbar>

    <div class="flex flex-wrap items-center justify-center p-6" slot="footer">
      <vs-button class="mr-6" @click="addData">提交修改</vs-button>
      <vs-button type="border" color="danger" @click="isSidebarActiveLocal = false">取消</vs-button>
    </div>
  </vs-sidebar>
</template>

<script>

import { updateProfile } from '@/api/user'
import { getToken } from '@/utils/tools';
import VuePerfectScrollbar from 'vue-perfect-scrollbar'

export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    model: {
      type: Boolean,
      required: true
    },
    info: {
      type: Object,
      required: true,
    }
  },
  data() {
    return {
      userInfo: {},
      settings: { // perfectscrollbar settings
          maxScrollbarLength: 60,
          wheelSpeed: .60,
      },
    }
  },
  computed: {
    isSidebarActiveLocal: {
      get() {
        this.initValues()
        return this.isSidebarActive
      },
      set(val) {
        if(!val) {
          this.$emit('closeSidebar');
        }
      }
    },
  },
  created() {
  },
  methods: {
    initValues() {
      this.userInfo = this.info
    },
    addData() {
      let that = this
      console.log(that.userInfo)
      updateProfile({
        access_token: getToken(),
        nickname: that.userInfo.displayName,
        phone: that.userInfo.phone,
        email: that.userInfo.email,
        avatar: that.userInfo.photoURL,
        motto: that.userInfo.motto
      }).then(res => {
        const data = res.data
        localStorage.setItem('judgeInfo', JSON.stringify(that.userInfo))
        this.$vs.notify({
          title:'成功',
          text: data.err_msg,
          color:'success',
          iconPack: 'feather',
          icon:'icon-alert-circle'
        })
        that.$emit('closeSidebar', true);
      })
    },
  },
  components: {
    VuePerfectScrollbar,
  }
}
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  /deep/ .vs-sidebar--background {
    z-index: 52010;
  }

  /deep/ .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;
  }
}

.scroll-area--data-list-add-new {
  height: calc(100% - 4.3rem);
}

.default-avatar:hover {
  cursor: pointer;
  border-radius: 6px;
  box-shadow: 1px 1px 10px #eee;
}
</style>
